import { createStyles, makeUiStyles, Theme } from '../../../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    gap: 16,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  }
}), { name: 'ProcessButtonsWrapper', index: StylesIndexInjections.UI_ATOMS });
